import {
  ICreateOrUpdateProjectIQWorkspace,
  IProjectIQWorkspace,
} from "models/IProjectIQWorkspace";

export const DIALOG_LABELS = {
  CREATE_TITLE: "Add Project IQ Workspace",
  EDIT_TITLE: "Update Project IQ Workspace",
  WORKSPACE_NAME: "Workspace Name",
  CLIENT_NAME: "Client Name",
  PROJECT_CODE: "Project Code",
  PORTFOLIO: "Portfolio",
  PRACTICES: "Practices",
  DESCRIPTION: "Description",
  OWNERS: "Owners",
  TEAM_MEMBERS: "Team Members",
  SAVING: "Saving",
  CREATING: "Creating",
  TAB_DETAILS: "Details",
  TAB_CAPABILITIES: "Capabilities",
  TAB_CONTEXT: "Context & Data",
  TAB_MICROSOFT_TEAMS: "Microsoft Teams",
  TAB_BRANDING: "Branding",
  CUSTOM_BRANDING_LABEL: "Custom Branding",
  CUSTOM_BRANDING_HINT:
    "Enable to customize the logo and colors shown in the client portal.",
  CLIENT_LOGO_LABEL: "Client Logo",
  HEADER_COLOR_LABEL: "Header Color",
  ACCENT_COLOR_LABEL: "Accent Color",
} as const;

export type WorkspaceTab = "details" | "settings" | "context"  | "branding" | "microsoftTeams";

export interface IEditProjectIqWorkspaceDialogProps {
  isOpen: boolean;
  workspace: IProjectIQWorkspace | null;
  onDismiss: (success: boolean, workspace?: IProjectIQWorkspace) => void;
  onSave?: (
    id: string,
    payload: ICreateOrUpdateProjectIQWorkspace,
  ) => Promise<IProjectIQWorkspace>;
  initialTab?: WorkspaceTab;
}

export const HEX_COLOR_PATTERN = /^#[0-9A-Fa-f]{6}$/;
export const HEX_COLOR_VALIDATION_MESSAGE =
  "Enter a valid hex color (e.g. #102A43).";

export interface ISyncWorkspaceLogoOptions {
  logoFile: File | null;
  headerLogoUrl: string;
  originalLogoUrl?: string;
  customBrandingEnabled: boolean;
}

export interface ISyncWorkspaceLogoResult {
  headerLogoUrl?: string | null;
}
